<template>
  <v-card min-width="300" light outlined>
    <v-card-title class="py-3 justify-center" style="background-color: #d2d7e1">
      <h2>{{ title }}</h2>
    </v-card-title>
    <v-card-text class="py-7 text-center justify-center">
      <p>{{ description }}</p>
      <v-btn v-if="type === 'NOT_ACTIVATED'" class="mr-3" @click="goToConfirmEmail">{{ messageBtn }}</v-btn>
      <v-btn @click="close">{{ $t((type === 'NOT_ACTIVATED')? 'closeBtn' : 'understoodBtn') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LoginError",
  props: {
    type: String,
    email: String,
    password: String,
  },
  data() {
    return {
      title: '',
      description: '',
      messageBtn: ''
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    type() {
      this.init();
    }
  },
  methods: {
    init() {
      if(this.type === 'NOT_ACTIVATED') {
        this.title = this.$t('notActivated.title');
        this.description = this.$t('notActivated.description');
        this.messageBtn = this.$t('notActivated.messageBtn');
      }
      else if(this.type === 'NOT_CREDENTIALS') {
        this.title = this.$t('notCredentials.title');
        this.description = this.$t('notCredentials.description');
      }
      else {
        this.title = this.$t('unexpected.title');
        this.description = this.$t('unexpected.description');
      }
    },
    goToConfirmEmail() {
      this.$router.push({ name: 'confirmed-email', params: { email: this.email, password: this.password } });
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "notActivated": {
      "title": "Not activated yet",
      "description": "Your account has not been activated yet",
      "messageBtn": "Activate Account »"
    },
    "notCredentials": {
      "title": "Invalid credentials",
      "description": "The credentials does not match with an account"
    },
    "unexpected": {
      "title": "There's an error",
      "description": "There's an unexpected error"
    },
    "understoodBtn": "Understood!",
    "closeBtn": "Close"
  },
  "es": {
    "notActivated": {
      "title": "Cuenta no activada",
      "description": "Su cuenta no ha sido activada aún",
      "messageBtn": "Activar Cuenta »"
    },
    "notCredentials": {
      "title": "Credenciales Inválidas",
      "description": "Las credenciales no coinciden con una cuenta"
    },
    "unexpected": {
      "title": "Hay un error",
      "description": "Hay un error inesperado"
    },
    "understoodBtn": "¡Entendido!",
    "closeBtn": "Cerrar"
  }
}
</i18n>